import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { StatusBadge } from '@/components/common/Badge/Status'
import type { BulkPaymentAllocation } from '@/modules/bill/services/bill'
import { formatNumber } from '@/utils/number'

type AllocationPreviewTableProps = {
  allocations: BulkPaymentAllocation[]
}

export function AllocationPreviewTable({ allocations }: AllocationPreviewTableProps) {
  if (!allocations.length) {
    return <p className="text-sm text-muted-foreground">ยังไม่มีการตัดยอด — กดดูการตัดยอดหลังกรอกยอดรับ</p>
  }

  return (
    <div className="overflow-x-auto rounded-lg border border-border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>เลขที่บิล</TableHead>
            <TableHead>วันที่บิล</TableHead>
            <TableHead className="text-right">ยอดบิล</TableHead>
            <TableHead className="text-right">ค้างก่อนตัด</TableHead>
            <TableHead className="text-right">รับครั้งนี้</TableHead>
            <TableHead className="text-right">คงค้าง</TableHead>
            <TableHead>ผลลัพธ์</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {allocations.map((row) => (
            <TableRow key={row.bill_id}>
              <TableCell>{row.bill_number ?? '—'}</TableCell>
              <TableCell>{row.bill_date}</TableCell>
              <TableCell className="text-right">
                {row.bill_total != null ? formatNumber(row.bill_total) : '—'}
              </TableCell>
              <TableCell className="text-right">
                {formatNumber(row.remaining_before ?? 0)}
              </TableCell>
              <TableCell className="text-right font-medium text-primary">
                {formatNumber(row.allocated_amount)}
              </TableCell>
              <TableCell className="text-right">{formatNumber(row.remaining_after)}</TableCell>
              <TableCell>
                {row.closes_fully ? (
                  <StatusBadge variance="primary">ปิดบิลแล้ว</StatusBadge>
                ) : (
                  <StatusBadge variance="cancel">
                    งวดที่ {row.round_no ?? '—'}
                  </StatusBadge>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
